import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _get from 'lodash/get';
import _has from 'lodash/has';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isFunction from 'lodash/isFunction';
import _isNil from 'lodash/isNil';
import _isObject from 'lodash/isObject';
import _isString from 'lodash/isString';
import _keys from 'lodash/keys';
import _set from 'lodash/set';
export var ALL_FIELDS_KEY = '__all__';
export var INTERNAL_INDEX_KEY = '__itemIndex__';
export function getValidProps(props, validPropOptions) {
  if (!props || !_isObject(props) || _isEmpty(validPropOptions)) {
    return {};
  }
  var validProps = {};
  Object.keys(props).forEach(function (key) {
    if (validPropOptions.includes(key)) {
      validProps[key] = props[key];
    }
  });
  return validProps;
}
export function isKeyPath(key) {
  return key.includes('.');
}
export function getItemKey(item, key) {
  if (_isNil(key)) {
    return JSON.stringify(item);
  }
  if (_isString(item)) {
    return item;
  }
  if (!_has(item, key)) {
    return JSON.stringify(item);
  }
  var value = item[key];
  if (_isNil(value)) {
    return JSON.stringify(item);
  }
  return value;
}
export function derivePropsFromObject(obj, propKeyMap) {
  var objects = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    itemIndex = _ref.itemIndex;
  return _keys(propKeyMap).reduce(function (acc, propName) {
    var itemKeyOrFunc = propKeyMap[propName];
    var propValue = _isFunction(itemKeyOrFunc) ? itemKeyOrFunc(obj, objects) : _get(obj, itemKeyOrFunc);
    if (itemKeyOrFunc === ALL_FIELDS_KEY) {
      propValue = obj;
    }
    if (isKeyPath(propName)) {
      return _set(acc, propName, propValue);
    }
    if (itemKeyOrFunc === INTERNAL_INDEX_KEY) {
      propValue = itemIndex;
    }
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, propName, propValue));
  }, {});
}
export function derivePropsFromArray(list, propKeyList) {
  return propKeyList.reduce(function (acc, propName, index) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, propName, list[index]));
  }, {});
}
export function derivePropsFromIterable(iterable, propIterable) {
  if (_isArray(iterable)) {
    return derivePropsFromArray(iterable, propIterable);
  }
  return derivePropsFromObject(iterable, propIterable);
}
export function areRequiredPropsDefined() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var requiredProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  /*
   * Returns if all required props specified are defined in a group of props.
   *
   * @param  object props group of props
   * @param  array requiredProps list of lists specifying which props are required.
   * Elements inside a list are applied OR operations and between lists AND operations are applied.
   * @return boolean whether or all required props are defined.
   */
  if (_isEmpty(requiredProps)) {
    return true;
  }

  // first apply OR operations to the internal lists
  var results = requiredProps.map(function (requiredProp) {
    if (_isString(requiredProp)) {
      return !!_get(props, requiredProp);
    }
    return requiredProp.reduce(function (accum, currentPropName) {
      return accum || !!_get(props, currentPropName);
    }, false);
  });

  // finally apply AND operations to the resulting boolean values
  return results.every(function (result) {
    return !!result;
  });
}